import { render, staticRenderFns } from "./DropdownContent.vue?vue&type=template&id=95c696de&"
import script from "./DropdownContent.vue?vue&type=script&lang=js&"
export * from "./DropdownContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports